export default class AbstractSection
{
  constructor()
  {
  }

  on_enter()
  {
  }

  update()
  {
  }

  on_exit()
  {
  }

  show()
  {
  }

  hide()
  {
  }

  on_resize()
  {}
}
